import { render, staticRenderFns } from "./VeMayBayForm.vue?vue&type=template&id=7529f8e6"
import script from "./VeMayBayForm.vue?vue&type=script&lang=js"
export * from "./VeMayBayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports